import MicIcon from "@mui/icons-material/Mic";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {useParams} from "react-router-dom";
import type {TabRoute} from "../layout/PageShell";
import {PageShell} from "../layout/PageShell";
import VoiceNoteRecorder from "./recorder/VoiceNoteRecorder";
import VoiceNoteList from "./VoiceNoteList";

export function VoiceNote() {
    const {t} = useLocalize();
    const {appId} = useParams<"appId">();

    if (!appId) return null;

    const tabRoutes: TabRoute[] = [
        {
            path: `/voiceNote/${appId}/recorder`,
            label: t("Recorder"),
            render: () => <VoiceNoteRecorder/>,
        },
        {
            path: `/voiceNote/${appId}/list`,
            label: t("List"),
            render: () => <VoiceNoteList/>,
        },
    ];

    return (
        <PageShell
            icon={<MicIcon/>}
            title={t("Voice Notes")}
            documentTitle={t("Voice Notes")}
            tabs={tabRoutes}
        />
    );
}
